import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const greetingStyles = makeStyles({
  root: {
    fontSize: '16px',
    '& p': {
      fontSize: '16px',
      textTransform: 'capitalize',
    },
  },
});

export default function Greeting(props) {
  const { name } = props;
  const classes = greetingStyles();

  return (
    <>
      {name && (
        <Box className={classes.root}>
          <Typography>
            Olá, <strong>{name}</strong>
          </Typography>
        </Box>
      )}
    </>
  );
}

Greeting.propTypes = {
  name: PropTypes.string,
};

Greeting.defaultProps = {
  name: 'Cliente',
};
